export default __webpack_public_path__ + "static/media/logotrimatra.287e4bd4.png";